import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TypedLogo } from './TypedLogo';

export function Navigation() {
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();
    const [_isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 20;
            if (isScrolled !== scrolled) {
                setScrolled(isScrolled);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [scrolled]);

    const isActive = (path: string) => location.pathname === path;
    const whyTechfolioUnderlinePosition = (location.pathname === '/signin' || location.pathname === '/signup') ? 'right-0' : 'left-0';
    const signInUnderlinePosition = location.pathname === '/signup' ? 'right-0' : 'left-0';
    const signUpUnderlinePosition = 'left-0';

    return (
        <nav className="fixed w-full z-[100] flex justify-center pt-5 px-4 md:px-0">
    <div
        className={`relative bg-zinc-900 rounded-2xl border ${scrolled ? 'border-neutral-700' : 'border-neutral-800'
            } px-4 md:px-8 w-full md:w-[1000px] transition-all duration-300 ease-in-out`}
    >
        <div className="flex h-12 items-center justify-between">
            <div className="flex items-center">
                <TypedLogo showAnimation={true} />
            </div>

            
                    <div className="flex items-center space-x-3 md:space-x-6">
                        <Link
                            to="/why-techfolio"
                            className={`${isActive('/why-techfolio')
                                ? 'text-white'
                                : 'text-neutral-400 hover:text-white'} transition-colors text-sm font-medium relative group`}
                        >
                            <span>Why Techfolio?</span>
                            <span className={`absolute -bottom-1 ${isActive('/why-techfolio') ? 'w-full' : 'w-0'} left-0 h-0.5 bg-white transition-all duration-300 group-hover:w-full`}></span>
                        </Link>
                        <Link
                            to="/signin"
                            className={`${isActive('/signin')
                                ? 'text-white'
                                : 'text-neutral-400 hover:text-white'} transition-colors text-sm font-medium relative group`}
                        >
                            <span>Sign In</span>
                            <span className={`absolute -bottom-1 ${isActive('/signin') ? 'w-full' : 'w-0'} ${signInUnderlinePosition} h-0.5 bg-white transition-all duration-300 group-hover:w-full`}></span>
                        </Link>
                        <Link
                            to="/signup"
                            className={`${isActive('/signup')
                                ? 'text-white'
                                : 'text-neutral-400 hover:text-white'} transition-colors text-sm font-medium relative group`}
                        >
                            <span>Sign Up</span>
                            <span className={`absolute -bottom-1 ${isActive('/signup') ? 'w-full' : 'w-0'} ${signUpUnderlinePosition} h-0.5 bg-white transition-all duration-300 group-hover:w-full`}></span>
                        </Link>
                    </div>
                </div>
            </div>
        </nav>
    );
}